import { BtixConstant } from "../../../constant";
import axios from "axios";
export const initVipCodeArea = () => {
    const vipCodeArea = document.getElementById("vip-code-area");
    if (vipCodeArea === null) {
        if (BtixConstant.debugMode) {
            window.console.log("Not Found vipCodeArea");
        }
        return;
    }
    const vipNotification = document.getElementById("vip-notification");
    const eventId = document.querySelector("input[type=hidden][name=event_id]").value;
    const familyNameInput = document.getElementById("family_name");
    const firstNameInput = document.getElementById("first_name");
    // vipコード入力時のイベント
    vipCodeArea.addEventListener("input", function () {
        const familyNameInput = document.getElementById("family_name");
        const familyName = familyNameInput.value;
        const firstNameInput = document.getElementById("first_name");
        const firstName = firstNameInput.value;
        const errorMessageP = vipCodeArea.querySelector(".form-error-message");
        if (familyName === "" || firstName === "") {
            /*errorMessageP.innerText = "先にお名前の入力をお願いします。";*/
            vipNotification.classList.add("area-hide");
        }
        else {
            errorMessageP.innerText = "";
            const preVipCodeInput = document.getElementById("vip_code_1");
            const postVipCodeInput = document.getElementById("vip_code_2");
            const preVipCode = preVipCodeInput.value;
            const postVipCode = postVipCodeInput.value;
            const vipCode = preVipCode + postVipCode;
            if (vipCode.length === 8) {
                const name = familyName + firstName;
                checkValidVipCode(preVipCode, postVipCode, Number(eventId), name);
            }
            else {
                vipNotification.classList.add("area-hide");
            }
        }
    });
    // 名前入力時のイベント
    familyNameInput.addEventListener("input", function () {
        handlingInputName();
    });
    firstNameInput.addEventListener("input", function () {
        handlingInputName();
    });
};
function handlingInputName() {
    const familyNameInput = document.getElementById("family_name");
    const familyName = familyNameInput.value;
    const firstNameInput = document.getElementById("first_name");
    const firstName = firstNameInput.value;
    const eventId = document.querySelector("input[type=hidden][name=event_id]").value;
    const preVipCodeInput = document.getElementById("vip_code_1");
    const postVipCodeInput = document.getElementById("vip_code_2");
    const preVipCode = preVipCodeInput.value;
    const postVipCode = postVipCodeInput.value;
    const vipCode = preVipCode + postVipCode;
    if (vipCode.length === 8) {
        if (familyName !== "" && firstName !== "") {
            const name = familyName + firstName;
            checkValidVipCode(preVipCode, postVipCode, Number(eventId), name);
        }
    }
}
function checkValidVipCode(preVipCode, postVipCode, eventId, name) {
    const sendData = {
        preCode: preVipCode,
        postCode: postVipCode,
        name: name,
        event_id: eventId,
    };
    axios
        .post(BtixConstant.apiUrl.validateVipCode, sendData, BtixConstant.axiosRequestConfig())
        .then(() => {
        const vipCodeArea = document.getElementById("vip-code-area");
        const errorMessageP = vipCodeArea.querySelector(".form-error-message");
        const vipNotification = document.getElementById("vip-notification");
        errorMessageP.innerText = "";
        vipNotification.classList.remove("area-hide");
    });
}
